import { createFileRoute } from '@tanstack/react-router'

import CourseGenericOverview from '@/course-generic/components/CourseGenericOverview/CourseGenericOverview'

export const Route = createFileRoute(
  '/_learning/discover/course-generic/$courseSlug/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { courseSlug } = Route.useParams()
  return <CourseGenericOverview courseSlug={courseSlug} />
}
